export const COMPOUND_LINK =
  "https://app.compound.finance/?market=usdc-lineagoerli&testnet=";
export const SUSHISWAP_LINK =
  "https://sushiswap.goerli.linea.build/swap?fromChainId=59140";
export const VELOCORE_LINK = "https://linea.velocore.xyz/swap";
export const PANCAKESWAP_LINK =
  "https://pancakeswap.finance?chain=lineaTestnet";
